<template>
	<page>
		<module enable-flex>
			<view-list :work-type="workType" ref="view" selector :view-config="auth('b_bake_task_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="关键字">
							<c-input name="keyword" placeholder="工单/产品/工序/机台/点位"></c-input>
						</m-search-item>
						<m-search-item label="工单编号">
							<c-input name="work_code"></c-input>
						</m-search-item>
						<m-search-item label="机台编号">
							<c-input name="equipment_code"></c-input>
						</m-search-item>
						<m-search-item label="点位编码">
							<c-input type="number" name="point_code"></c-input>
						</m-search-item>
						<m-search-item label="烘烤状态">
							<c-select name="bake_states" multiple :options="bakeStateDic"></c-select>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_bake_task_export')" v-lock="lock('b_bake_task_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_bake_task_export')" v-lock="lock('b_bake_task_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>

				<template #target_temp="{data}">
					<span>{{data.target_temp != null ? data.target_temp + '℃' : '-'}}</span>
				</template>

				<template #target_duration="{data}">
					<span>{{data.target_duration != null ? formatMinutes(data.target_duration) : '-'}}</span>
				</template>
				
				<template #effective_bake_minutes="{data}">
					<span>{{data.effective_bake_minutes != null ? formatMinutes(data.effective_bake_minutes) : '-'}}</span>
				</template>

				<template #max_temp="{data}">
					<span>{{data.max_temp != null ? data.max_temp + '℃' : '-'}}</span>
				</template>

				<template #sync_status="{data}">
					<c-state dict="bakeSyncStatusDic" :value="data.sync_status != null ? data.sync_status : 0"></c-state>
					<span v-if="data.sync_status == 2 && data.sync_message" class="sync-fail-tip" :title="data.sync_message">{{ data.sync_message }}</span>
				</template>

				<template #bake_state="{data}">
					<c-state dict="bakeStateDic" :value="data.bake_state" v-if="data.bake_state != 2"></c-state>
					<span v-else :class="{'bake-state-warming': data.is_warming_up == 1}">{{data.is_warming_up == 1 ? '升温中' : '烘烤中'}}</span>
					<span v-if="data.is_duration_met == 1 && data.bake_state == 2" class="duration-met-badge">待确认</span>
				</template>

				<template #plan_count="{data}">
					<span v-if="data.repair_count != null && data.repair_count > 0">{{data.plan_count != null ? data.plan_count - data.repair_count : '-'}}</span>
					<span v-else>{{data.plan_count != null ? data.plan_count : '-'}}</span>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="220"
					button-limit="4"
				>
					<template #default="{data}">
						<c-table-button v-if="data.bake_state == 2 && data.sync_status == 2" icon="tf-refresh" @click="confirmRetry(data)">重试下发</c-table-button>
						<c-table-button v-if="data.bake_state == 2 && data.sync_status == 2 && auth('b_bake_task_cancel')" icon="tf-cancel" @click="confirmCancelFailed(data)">取消</c-table-button>
						<c-table-button v-if="auth('b_bake_task_temperature_chart') && data.bake_state != 4 && data.sync_status == 1" icon="tf-chart" @click="openChartDialog(data)">温度曲线</c-table-button>
						<c-table-button v-if="data.bake_state == 2 && data.is_duration_met == 1 && auth('b_bake_task_complete')" icon="tf-check" @click="confirmComplete(data)">确认完成</c-table-button>
						<c-table-button v-if="data.bake_state == 2 && data.is_duration_met != 1 && auth('b_bake_task_repair')" icon="tf-repair" @click="openRepairDialog(data)">维修</c-table-button>
						<c-table-button v-if="data.bake_state == 2 && data.is_duration_met != 1 && data.sync_status != 2 && auth('b_bake_task_cancel')" icon="tf-cancel" @click="cancel(data)">取消</c-table-button>
					</template>
				</c-table-column>
			</view-list>

			<c-dialog ref="repairDialog" title="烘烤任务维修" width="420px" :button="false" @close="closeRepairDialog">
				<div class="repair-form">
					<div class="repair-form-item">
						<label class="repair-label">维修数量</label>
						<c-input v-model="repairForm.repair_count" type="number" placeholder="请输入维修数量"></c-input>
					</div>
					<div class="repair-form-item repair-form-tip">
						将从计划数量中扣除，已维修：{{ currentRow.repair_count || 0 }}，计划：{{ currentRow.plan_count || 0 }}
					</div>
					<div class="repair-form-actions">
						<c-button color="main" @click="submitRepair">确定</c-button>
						<c-button hollow @click="$refs.repairDialog.close()">取消</c-button>
					</div>
				</div>
			</c-dialog>

			<c-dialog ref="chartDialog" title="烘烤温度曲线" width="1200px" height="500px" :button="false" @close="closeChartDialog">
				<div class="dialog-chart-info">
					<span class="dialog-info-item">工单：{{ dialogItem.work_code || '-' }}</span>
					<span class="dialog-info-item">机台：{{ dialogItem.equipment_code || '-' }}</span>
					<span class="dialog-info-item">点位：{{ dialogItem.point_code != null ? dialogItem.point_code : '-' }}</span>
					<span class="dialog-info-item">目标温度：{{ dialogItem.target_temp || '-' }}℃</span>
				</div>
				<div ref="dialogChart" class="dialog-chart"></div>
			</c-dialog>
		</module>
	</page>
</template>

<script>
	import * as echarts from 'echarts'
	import {mapState} from 'vuex'

	export default {
		data() {
			return {
				workType: 72,
				currentRow: {},
				repairForm: {
					repair_count: ''
				},
				dialogItem: {},
				dialogChartInstance: null,
				dialogChartData: null
			}
		},

		computed: {
			...mapState(['bakeStateDic'])
		},

		methods: {
			formatMinutes(minutes) {
				let m = parseInt(minutes) || 0
				if (m <= 0) return '0分钟'
				if (m < 60) return m + '分钟'
				let hours = Math.floor(m / 60)
				let left = m % 60
				return left > 0 ? hours + '小时' + left + '分' : hours + '小时'
			},

			/******打开温度曲线弹窗*******/
			openChartDialog(data) {
				if (!data.id) return
				this.dialogItem = data
				this.loadDialogChartData(data, 'all')
			},
					
			loadDialogChartData(data, range) {
				this.dialogChartData = null
				this.request({
					url: '/bake/task/recordList',
					data: { bake_task_id: data.id, range: range },
					success: data => {
						let records = data || []
						let targetTemp = parseFloat(this.dialogItem.target_temp) || 0
						let tolerance = parseFloat(this.dialogItem.temp_tolerance) || 0
						this.dialogChartData = { records, targetTemp, tolerance }
						this.$refs.chartDialog.open()
						this.$nextTick(() => {
							setTimeout(() => {
								this.doRenderDialogChart()
							}, 300)
						})
					}
				})
			},
			
			doRenderDialogChart() {
				let dom = this.$refs.dialogChart
				if (!dom || !this.dialogChartData) return
				if (this.dialogChartInstance) {
					this.dialogChartInstance.dispose()
				}
				this.dialogChartInstance = echarts.init(dom)
				let cd = this.dialogChartData
				let records = cd.records
				let times = records.map(r => {
					let d = new Date(r.record_time)
					return `${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`
				})
				let temps = records.map(r => {
					let v = r.current_temp
					return (v === null || v === undefined || v === '') ? null : parseFloat(v)
				})
				let lower = cd.targetTemp - cd.tolerance
				let upper = cd.targetTemp + cd.tolerance
				let markAreas = []
				let inValid = false
				let startIndex = -1
				temps.forEach((temp, index) => {
					if (temp !== null && temp >= lower && temp <= upper) {
						if (!inValid) {
							inValid = true
							startIndex = index
						}
					} else {
						if (inValid) {
							markAreas.push([{ xAxis: times[startIndex] }, { xAxis: times[index - 1] }])
							inValid = false
						}
					}
				})
				if (inValid) {
					markAreas.push([{ xAxis: times[startIndex] }, { xAxis: times[times.length - 1] }])
				}
				
				let validTemps = temps.filter(t => t !== null)
				let maxTemp = validTemps.length ? Math.max(...validTemps) : 0
				
				this.dialogChartInstance.setOption({
					grid: { top: 30, right: 30, bottom: 40, left: 60 },
					tooltip: {
						trigger: 'axis',
						backgroundColor: 'rgba(15, 23, 42, 0.9)',
						borderColor: 'rgba(56, 189, 248, 0.3)',
						textStyle: { color: '#e2e8f0' },
						formatter: params => {
							let p = params[0]
							if (p.value === null || p.value === undefined) {
								return p.name + '<br/>温度：无数据'
							}
							return p.name + '<br/>温度：' + p.value + '℃'
						}
					},
					xAxis: {
						type: 'category',
						data: times,
						axisLine: { lineStyle: { color: '#94a3b8' } },
						axisLabel: { color: '#94a3b8', fontSize: 11, interval: Math.max(1, Math.floor(times.length / 8)) }
					},
					yAxis: {
						type: 'value',
						name: '温度(℃)',
						nameTextStyle: { color: '#94a3b8' },
						min: 0,
						max: Math.ceil((Math.max(maxTemp, cd.targetTemp + cd.tolerance) + 5) / 10) * 10,
						axisLine: { show: false },
						axisLabel: { color: '#94a3b8', fontSize: 11 },
						splitLine: { lineStyle: { color: 'rgba(148, 163, 184, 0.15)' } }
					},
					series: [{
						data: temps,
						type: 'line',
						smooth: true,
						connectNulls: false,
						symbol: 'none',
						lineStyle: { color: '#38bdf8', width: 2 },
						areaStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(56,189,248,0.25)' }, { offset: 1, color: 'rgba(56,189,248,0)' }]) },
						markLine: {
							symbol: 'none',
							data: [{
								yAxis: cd.targetTemp,
								lineStyle: { color: '#4ade80', type: 'dashed', width: 1 },
								label: { formatter: '目标' + cd.targetTemp + '℃', fontSize: 10, color: '#4ade80' }
							}]
						},
						markArea: {
							itemStyle: { color: 'rgba(74,222,128,0.12)' },
							data: markAreas
						}
					}]
				})
				this.dialogChartInstance.resize()
			},
			
			closeChartDialog() {
				if (this.dialogChartInstance) {
					this.dialogChartInstance.dispose()
					this.dialogChartInstance = null
				}
				this.dialogChartData = null
			},
			
			/******确认完成*******/
			confirmComplete(data) {
				this.$confirm({
					message: '确认该烘烤任务已完成？确认后任务状态将变更为已完成状态。',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/bake/task/confirmComplete',
							data: {id: data.id},
							loading: true,
							success: () => {
								this.$message({
									message: '确认完成成功',
									type: 'success'
								});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/******维修*******/
			openRepairDialog(data) {
				this.currentRow = data || {}
				this.repairForm.repair_count = ''
				this.$refs.repairDialog.open()
			},
			
			closeRepairDialog() {
				this.currentRow = {}
				this.repairForm.repair_count = ''
			},
			
			submitRepair() {
				let value = this.repairForm.repair_count
				if (!value || parseFloat(value) <= 0) {
					this.$message({
						message: '维修数量必须大于0',
						type: 'warn'
					});
					return;
				}
				this.request({
					url: '/bake/task/repair',
					data: {
						id: this.currentRow.id,
						repair_count: value
					},
					loading: true,
					success: () => {
						this.$message({
							message: '维修操作成功',
							type: 'success'
						});
						this.$refs.repairDialog.close()
						this.$refs.view.update();
					}
				});
			},

			/******重试下发*******/
			confirmRetry(data) {
				this.$confirm({
					message: '确认重新下发该烘烤任务？系统将重新调用三方接口下发任务参数。',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/bake/task/retrySend',
							data: {id: data.id},
							loading: true,
							success: () => {
								this.$message({
									message: '重试下发成功，等待三方确认',
									type: 'success'
								});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/******取消下发失败的物理删除*******/
			confirmCancelFailed(data) {
				this.$confirm({
					message: '确认取消该下发失败的烘烤任务？取消后将物理删除该任务及相关数据，不可恢复。',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/bake/task/cancelFailed',
							data: {id: data.id},
							loading: true,
							success: () => {
								this.$message({
									message: '取消成功',
									type: 'success'
								});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/******取消*******/
			cancel(data) {
				this.$confirm({
					message: '确认取消该烘烤任务吗？取消后任务状态将变更为“已取消”，该操作不可恢复。',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/bake/task/cancel',
							data: {id: data.id},
							loading: true,
							success: () => {
								this.$message({
									message: '取消成功',
									type: 'success'
								});
								this.$refs.view.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.bake-state-warming {
		color: #ff9800;
	}
	.duration-met-badge {
		display: inline-block;
		margin-left: 6px;
		padding: 0 4px;
		font-size: 12px;
		color: #fff;
		background: #52c41a;
		border-radius: 2px;
		line-height: 18px;
	}

	.sync-fail-tip {
		display: inline-block;
		margin-left: 4px;
		max-width: 120px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 12px;
		color: #cf1322;
		vertical-align: middle;
	}

	.repair-form
		padding 20px

	.repair-form-item
		margin-bottom 16px

	.repair-label
		display block
		margin-bottom 8px
		font-size 14px
		color #475569

	.repair-form-tip
		font-size 13px
		color #94a3b8

	.repair-form-actions
		display flex
		justify-content flex-end
		gap 12px
		margin-top 24px

	.dialog-chart-info
		display flex
		flex-wrap wrap
		gap 16px 24px
		padding 14px 20px
		background #f8fafc
		border-bottom 1px solid #e2e8f0

	.dialog-info-item
		font-size 13px
		color #334155
		line-height 1.5

	.dialog-chart
		width 100%
		height 380px
</style>
